import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap, map } from "rxjs/operators";
import { FormArray } from "@angular/forms";
import { Payment } from "../models/payment";

@Injectable()
export class PaymentsService {
  constructor(private http: HttpClientService) {}

  public getUnverified(account_number = null): Observable<any> {
    const options = {
      params: {
        account_number,
      },
    };
    return this.http
      .get("/api/payments/unverified", options)
      .pipe(tap((_) => console.log("PaymentsService.getUnverified: Ok.")));
  }

  public getUnverifiedCount(account_number = null): Observable<any> {
    const options = {
      params: {
        account_number,
      },
    };
    return this.http
      .get("/api/payments/unverified_count", options)
      .pipe(tap((_) => console.log("PaymentsService.getUnverifiedCount: Ok.")));
  }

  public generateLayoutsCsv(domi_process_id): Observable<any> {
    return this.http
      .post(`/api/domiciliation_process/${domi_process_id}/generate_layouts`, {})
      .pipe(tap((_) => console.log("PaymentsService.postGenerateLayoutsCsv: Ok.")));
  }

  public findPaymentRows(ids: string[]): Observable<any> {
    const options = {
      ids,
    };
    return this.http
      .post("/api/domiciliation_process/find_payment_rows", options)
      .pipe(tap((_) => console.log("PaymentsService.getFindPaymentRows: Ok.")));
  }

  public approvePayment(id): Observable<any> {
    return this.http
      .post("/api/payments/" + id + "/approve", {})
      .pipe(tap((_) => console.log("PaymentsService.approvePayment: Ok.")));
  }
  public rejectPayment(id): Observable<any> {
    return this.http
      .post("/api/payments/" + id + "/reject", {})
      .pipe(tap((_) => console.log("PaymentsService.rejectPayment: Ok.")));
  }

  public postPayments(payments): Observable<any> {
    let options = {
      payments,
    };
    return this.http.post("/api/payments", options).pipe(tap((_) => console.log("PaymentsService.postPayments: Ok")));
  }

  public getPayments(account_number): Observable<any> {
    const options = {
      params: {
        account_number,
      },
    };
    return this.http
      .get("/api/accounts/payments", options)
      .pipe(tap((_) => console.log("PaymentsService.getPayments: Ok.")));
  }

  public getHistoryPaymentsFormArray({ page, page_size }): Observable<any> {
    return this.getHistoricPayments({ page, page_size }).pipe(
      map((payments: Payment[]) => {
        const fgs = payments["payments"].map(Payment.asFormGroup);
        return { payments: new FormArray(fgs), total: payments["pagination"]["total_count"] };
      })
    );
  }

  public getPaymentsToReconcile({
    page_number,
    page_size,
    start_date,
    end_date,
    payment_method = undefined,
    order_by = undefined,
    order_dir = undefined,
  }: any): Observable<Payment[]> {
    return this.http
      .get("/api/payments/to_reconcile", {
        params: { page_number, page_size, start_date, end_date, payment_method, order_by, order_dir },
      })
      .pipe(
        map((payments: Payment[]) => {
          return payments;
        })
      );
  }

  public getHistoricPayments({ page = undefined, page_size = undefined }) {
    const options = {
      params: {
        page,
        page_size,
      },
    };
    return this.http
      .get("/api/payments/historic_reconcile", options)
      .pipe(tap((_) => console.log("PaymentsService.by_reconcile_paginator: Ok.")));
  }

  public unverifiedPaymentsReconciled(id, data): Observable<any> {
    return this.http
      .put("/api/payments/" + id + "/unverified_reconciled", data)
      .pipe(tap((_) => console.log("PaymentsService.unverifiedPaymentsReconciled: Ok.")));
  }

  public rejectPaymentReconciled(id, { cancel_reason = "" }, same_payment = false): Observable<any> {
    const options = {
      cancel_reason,
      same_payment,
    };
    return this.http
      .put("/api/payments/" + id + "/reject_reconciled", options)
      .pipe(tap((_) => console.log("PaymentsService.rejectPaymentReconciled: Ok.")));
  }

  public revertPaymentReconciled(id): Observable<any> {
    return this.http
      .put("/api/payments/" + id + "/revert_reconcile", [])
      .pipe(tap((_) => console.log("PaymentsService.revertPaymentReconciled: Ok.")));
  }

  public createReconcilePayment(data) {
    return this.http
      .post("/api/payments/create_reconciled_payment", { data })
      .pipe(tap((_) => console.log("PaymentsService.createReconcilePayment: Ok.")));
  }

  public getReconcileCoincidences(data) {
    return this.http
      .post("/api/payments/previously_reconciled_payments", { data })
      .pipe(tap((_) => console.log("PaymentsService.previously_reconciled_payments: Ok.")));
  }
}
